<div class="body">
  @if (datosUsuario) {
    <div class="container">
      <div class="row title-box mt-3">
        <div class="col-12 col-sm-12">
          <h3 class="txtbienvenida">Consulta histórico <span class="txtbienvenida-2">de usuarios</span></h3>
        </div>
      </div>
      <form class="custom-form" [formGroup]="consulHistoUsuaForm">
        <div class="row justify-content-md-center mt-4">
          <div class="col-12 col-sm-6">
            <div class="mb-3 form-label">
              <label for="idTipoDocIdentidad_NeoTipoDocIdentidad"idTipoDocIdentidad_NeoTipoDocIdentidadz class="form-label">Tipo de documento</label>
              <select class="form-control" formControlName="idTipoDocIdentidad_NeoTipoDocIdentidad" (change)="validarSelect()">
                <option [value]="null">Seleccione una opción</option>
                @for (documento of documentos; track documento) {
                  <option [value]="documento.idTipoDocIdentidad">
                    {{ documento.nombre }}
                  </option>
                }
              </select>
            </div>
          </div>
          <div class="col-12 col-sm-6">
            <div class="mb-3 form-label">
              <label for="numeroDocumento" class="form-label">Número de documento</label>
              <input type="text" class="form-control" minlength="5" maxlength="10" formControlName="numeroDocumento"
                #input (input)="input.value=$event.target.value.toUpperCase()" (keypress)="validateDocument($event)">
              </div>
            </div>
          </div>
          <div class="row justify-content-md-start mt-4">
            <div class="col-12 col-sm-6">
              <div class="mb-3 form-label">
                <label for="estado" class="form-label">Estado</label>
                <select class="mb-3" data-width="100%" class="form-control" formControlName="estado">
                  <option value="null">Seleccione una opción</option>
                  <option value="HABILITADO">HABILITADO</option>
                  <option value="DESHABILITADO">DESHABILITADO</option>
                  <option value="BLOQUEADO">BLOQUEADO</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row justify-content-md-center mt-3 g-3">
            <div class="col-12 col-sm-3 container-btn">
              <button class="btn btn-primary hvr-shrink" (click)="consultaHistorico()" style="width: 180px;" type="submit">Consultar</button>
            </div>
            @if (datosTabla) {
              <div class="col-12 col-sm-3 container-btn"  >
                <button class="btn btn-primary hvr-shrink" style="width: 180px;" (click)="descargarExcel()" type="submit">Exportar a Excel</button>
              </div>
            }
            @if (datosTabla) {
              <div class="col-12 col-sm-3 container-btn"  >
                <button class="btn btn-primary hvr-shrink" style="width: 180px;" (click)="descargarTxt()" type="submit">Exportar a Txt</button>
              </div>
            }
            <div class="col-12 col-sm-3 container-btn">
              <button class="btn  btn-primary hvr-shrink" style="width: 180px;" routerLink="/intermediario/home">Volver</button>
            </div>
          </div>
          @if (datosTabla) {
            <div class="row mt-4 pr-3 pl-3" >
              <div class="table-responsive">
                <table class="table table-striped table-borderless rounded">
                  <thead class="table_head">
                    <tr>
                      <th scope="col" class="no-styles table-header" id="nombreUsuario">Nombres y Apellidos Usuario</th>
                      <th scope="col" class="no-styles table-header" id="tipoDoc">Tipo Documento y Numero del Usuario</th>
                      <th scope="col" class="no-styles table-header" id="rolesAsignados">Roles Usuario</th>
                      <th scope="col" class="no-styles table-header" id="estado">Estado de Usuario</th>
                      <th scope="col" class="no-styles table-header" id="accion">Ver Historico Modificaciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (usuario of listaUsuarios; track usuario; let i = $index) {
                      <tr>
                        <th scope="row">{{usuario.nombresYApellidos}}</th>
                        <td>{{usuario.tipoDocumento}} {{usuario.numeroDocumento}}</td>
                        <td>{{usuario.roles}}</td>
                        <td>{{usuario.estado}}</td>
                        <td>
                          <button id="btn-info" class="hvr-shrink" type="button" (click)="verHistorico(i)">
                            <i class="fas fa-eye"></i>
                          </button>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          }
          @if (datosTabla) {
            <app-pagination (event)="selectPage($event)" [paginaActual]="paginaActual"
            [totalPaginas]="totalPaginas"></app-pagination>
          }
          <a id="downloadFile" style="display: none;"></a>
        </form>
      </div>
    }

    @if (!datosUsuario) {
      <div class="container">
        <div class="row title-box mt-3">
          <div class="col-12 col-sm-12">
            <h3 class="txtbienvenida">Histórico <span class="txtbienvenida-2">modificaciones</span></h3>
          </div>
        </div>
        <form class="custom-form" [formGroup]="mostrarForm">
          <div class="row justify-content-md-center">
            <div class="col-12 ">
              <div class="mb-3 form-label">
                <label for="nombre" class="form-label">Nombre Usuario</label>
                <input disabled type="text" class="form-control" formControlName="nombre">
              </div>
            </div>
          </div>
        </form>
        <div class="row mt-4 pr-3 pl-3">
          <div class="table-responsive">
            <table class="table table-striped table-borderless rounded">
              <thead class="table_head">
                <tr>
                  <th scope="col" class="no-styles table-header" id="fechayHora">Fecha y hora modificación</th>
                  <th scope="col" class="no-styles table-header" id="nombreUsuario">Usuario que realizo la modificación</th>
                  <th scope="col" class="no-styles table-header" id="InfAnterior">Información anterior</th>
                  <th scope="col" class="no-styles table-header" id="NuevaInf">Nueva información</th>
                </tr>
              </thead>
              <tbody>
                @for (usuario of historicoUsuario; track usuario; let i = $index) {
                  <tr>
                    <th scope="row">{{usuario.fechayHoraModificacion}}</th>
                    <td>{{usuario.usuarioModifico}}</td>
                    <td>{{usuario.infoAnterior}}</td>
                    <td>{{usuario.infoNueva}}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
          <app-pagination  (event)="selectPage($event)" [paginaActual]="paginaActual"
          [totalPaginas]="totalPaginas"></app-pagination>
        </div>
        <div class="row justify-content-md-center mt-3 g-3">
          <div class="col-12 col-sm-3 container-btn">
            <button class="btn btn-primary hvr-shrink" style="width: 180px;" (click)="descargarExcelUsuario()" type="submit">Exportar a Excel</button>
          </div>
          <div class="col-12 col-sm-3 container-btn">
            <button class="btn btn-primary hvr-shrink" style="width: 180px;" (click)="descargarTxtUsuario()" type="submit">Exportar a Txt</button>
          </div>
          <div class="col-12 col-sm-3 container-btn">
            <button class="btn  btn-primary hvr-shrink" style="width: 180px;" (click)="ngOnInit()">Volver</button>
          </div>
        </div>
        <a id="downloadFile" style="display: none;"></a>
      </div>
    }

    <!-- Modal -->
    <div class="modal fade text-center" style="color: black;" id="mensajeModal" tabindex="-1" aria-labelledby="mensajeModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body justify-content-md-center">
            <div class="row">
              <div class="col-12 col-sm-12 me-3 ms-3">
                <h2>La consulta no arrojo resultados con los criterios ingresados</h2>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-md-center">
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Aceptar</button>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-body"></div>
  </div>
  <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
